import { useEffect, useState } from 'react';
import axios from 'axios';
import { OptionSet } from 'src/components/Tickets/models/Tickets.interface';

export const useGetTicketTypes = () => {
  const [ticketTypes, setTicketTypes] = useState<OptionSet[]>();
  const [isLoadingTicketTypes, setIsLoadingTicketTypes] = useState<boolean>();
  const [ticketTypesErrors, setTicketTypesErrors] = useState<unknown>();

  const getTicketTypes = async () => {
    setIsLoadingTicketTypes(true);
    try {
      const response = await axios.get('api/option-sets/ticket-types');
      setTicketTypes(response.data);
    } catch (error) {
      console.error(error);
      setTicketTypesErrors(error);
    } finally {
      setIsLoadingTicketTypes(false);
    }
  };

  useEffect(() => {
    getTicketTypes();
  }, []);

  return { ticketTypes, isLoadingTicketTypes, ticketTypesErrors };
};
